import { useEffect, useState } from 'react';

import { Textarea as KitTextarea } from '~/components/form';
import { AiFieldChrome } from '~/components/pages/ai/placements/preview/AiFieldChrome';
import type { PlacementPreviewFieldProps } from '~/components/pages/ai/placements/preview/TextField';
import { useAiTextActions } from '~/components/pages/ai/placements/preview/useAiTextActions';

/** The Text Area placement preview: the kit textarea inside the AI chrome (label row triggers, tip, disclaimer). */
export default function TextArea({
  aiDisableTooltip,
  aiDisabled,
  bracesButton,
  characterLimit,
  defaultValue = '',
  disabledTooltip,
  disclaimerText,
  emojiButton,
  errorText,
  isDisabled,
  isRunning,
  labelText = 'Text area',
  labelTooltip,
  onRunAi,
  placeholder,
  required,
  showDisclaimer,
  tipText,
}: PlacementPreviewFieldProps) {
  const [text, setText] = useState(defaultValue);
  const ai = useAiTextActions({
    aiDisabled,
    isDisabled,
    isRunning,
    onRunAi,
    onTextChange: setText,
    text,
  });

  useEffect(() => {
    setText(defaultValue);
  }, [defaultValue]);

  const fieldId = 'placement-preview-text-area';

  return (
    <div title={isDisabled ? disabledTooltip : undefined}>
      <AiFieldChrome
        ai={ai}
        aiDisabled={aiDisabled}
        aiDisabledReason={aiDisableTooltip}
        bracesButton={bracesButton}
        characterLimit={characterLimit}
        disclaimerText={disclaimerText}
        emojiButton={emojiButton}
        fieldId={fieldId}
        hasAiHandler={Boolean(onRunAi)}
        isDisabled={isDisabled}
        labelText={labelText}
        labelTooltip={labelTooltip}
        onTextChange={setText}
        required={required}
        showDisclaimer={showDisclaimer}
        testId={`${fieldId}-ai`}
        text={text}
        tipText={tipText}
      >
        <KitTextarea
          id={fieldId}
          label=""
          ariaLabel={labelText || 'Text area'}
          testId={`${fieldId}-input`}
          value={text}
          onChange={setText}
          placeholder={placeholder}
          rows={5}
          disabled={isDisabled}
          required={required}
          error={errorText}
          helperText={isDisabled ? disabledTooltip : undefined}
          maxLength={characterLimit}
        />
      </AiFieldChrome>
    </div>
  );
}
